import {
    Box,
    Button,
    Card,
    DialogActions,
    FormControl,
    MenuItem,
    Select,
    TextField,
    Typography,
} from '@mui/material';
import React, { useMemo, useState } from 'react';
import Image from '../../components/Image';
import { Form, Submit, useForm } from '../../hooks/useForm';
import { Input } from '../../hooks/useForm/inputs';
import { handleAxiosError } from '../../utilities/function';
import { authServer } from '../../utilities/axiosPrototypes';
import useSnack from '../../hooks/useSnack';
import { useMessage } from '../../providers/Provider';

const InviteUserModal = ({ closeModal, fetchOgranizationUser, openCopyModal }) => {
    const [organizationId] = useState(localStorage.getItem("selectedOrganization"))
    const [role, setRole] = useState('member');
    const { showSuccess, showError } = useMessage();
    const user = JSON.parse(localStorage.getItem("user"))
    const handlers = useForm(
        useMemo(
            () => ({
                email: '',
            }),
            []
        ),
        { Input: TextField }
    );    
    const submit = res => {
        const { success, message } = res.data;

        if (!message) return showError(`Can't Invite the user ${message}`);

        showSuccess(message);
        closeModal();
        fetchOgranizationUser();
        openCopyModal();
    };

    const handleChangeRole = e => {
        setRole(e.target.value);
    };

    return (
        <>
            <Card
                sx={{
                    boxShadow: 'rgba(0, 0, 0, 0.45) 0px 25px 20px -20px',
                    borderRadius: '8px',
                    maxWidth: '500px',
                    width: '100%',
                    p: 2,
                    m: 2,
                    my: 8,
                    maxHeight: '100vh',
                    overflowY: 'auto',
                    overflowX: 'hidden',
                }}>
                <Form
                    handlers={handlers}
                    onSubmit={submit}
                    // Update endpoint to match the new API route
                    action="/api/v2/organizations/invite"
                    method={'post'}
                    axiosInstance={authServer}
                    onError={e => handleAxiosError(e, showError)}
                    // Update final payload to match API requirements
                    final={values => ({
                        email: values.email,
                        type: role,  // Map role to type
                        organizationId: organizationId,
                        senderName:user.firstName + " " + user.lastName 
                    })}>
                    <Typography variant='h6'>Invite people to Organization</Typography>
                    <Typography variant='caption' color='text.secondary' sx={{ mb: 4 }}>
                        Invite teammates to collaborate and use products in your organization.
                    </Typography>
                    <Box sx={{ maxWidth: '150px', mx: 'auto', my: 3 }}>
                        <Image name='invite.svg' width='200' />
                    </Box>

                    <Typography variant='body2' sx={{ mb: 1 }}>
                        Email addresses <span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <Input
                        name='email'
                        variant='outlined'
                        placeholder='Invite by email address...'
                        fullWidth
                        size='small'
                    />
                    <Typography variant='body2' sx={{ mt: 1 }}>
                        Role <span style={{ color: 'red' }}>*</span>
                    </Typography>
                    <FormControl size='small' fullWidth>
                        <Select
                            size='small'
                            sx={{ fontSize: '14px' }}
                            value={role}
                            name='role'
                            onChange={handleChangeRole}>
                            {/* Ensure values match API expectations */}
                            <MenuItem value='owner'>Owner</MenuItem>
                            <MenuItem value='member'>Member</MenuItem>
                        </Select>
                    </FormControl>
                    <DialogActions sx={{ mt: 1 }}>
                        <Button onClick={closeModal} size='small'>
                            Cancel
                        </Button>
                        <Submit>
                            {loader => (
                                <Button
                                    type='submit'
                                    variant='contained'
                                    size='small'
                                    disabled={loader}
                                    endIcon={loader}>
                                    Invite user
                                </Button>
                            )}
                        </Submit>
                    </DialogActions>
                </Form>
            </Card>
        </>
    );
};

export default InviteUserModal;